import { render, staticRenderFns } from "./ExtFormDetail.vue?vue&type=template&id=7e9b8cb2&scoped=true&"
import script from "./ExtFormDetail.vue?vue&type=script&lang=js&"
export * from "./ExtFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExtFormDetail.vue?vue&type=style&index=0&id=7e9b8cb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9b8cb2",
  null
  
)

export default component.exports